import React from "react";
import {
  AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyStart,
} from "lucide-react";

/**
 * Get icon for contact sensor widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getContactSensorIcon = (widget = null) => {
  // Determine if contact is open or closed
  const isOpen = widget?.items?.$w1?.value === "open";

  const lucideIconProps = {
    size: 24,
    style: {
      paddingBottom: "2px",
    },
  };

  return isOpen ? (
    <AlignHorizontalJustifyStart {...lucideIconProps} />
  ) : (
    <AlignHorizontalJustifyCenter {...lucideIconProps} />
  );
};

export const getContactSensorSubtitle = (widget = null) => {
  if (!widget) return "";

  const isOpen = widget?.items?.$w1?.value === "open";
  return isOpen ? "Open" : "Closed";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getContactSensorPatterns = () => {
  return ["basic.device.contactsensor"];
};
